import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'digital-platform-message-bar',
  templateUrl: './message-bar.component.html',
  styleUrls: ['./message-bar.component.scss'],
})
export class MessageBarComponent {
  @HostBinding() class = 'digital-platform-message-bar';

  @Input() type: 'info' | 'error' | 'action-required' | 'alert' = 'info';
  @Input() icon = 'help_outline';
}
